<template>
    <jet-dialog-modal :show="isShow" maxWidth="3xl" @close="closePhotoChangePopUp" role="dialog" aria-modal="true">
        <template #title>
            <div class="text-lg">
                <div class="flex justify-between items-center">
                    <h2 class="sm:pt-4 pt-2 lg:text-2xl sm:text-lg text-sm mb-2"> Change Photo </h2>
                    <jet-secondary-button
                        class="cursor-pointer" aria-label="Close"
                        @click="closePhotoChangePopUp">X</jet-secondary-button>
                </div>
            </div>
        </template>

        <template #content>
            <div class="w-full">
                <form action="#" @submit.prevent="false">

                    <div class="loader-15" v-if="uploadProgress"></div>
                    <div v-else>

                        <div v-if="optionSetimage" class="relative w-24 mb-5 mx-auto">
                            <img :src="optionSetimage" class="xl:mt-0 w-full h-24 object-cover" width="100" height="100" alt="Recipe photo" />
                        </div>

                        <div class="space-y-8 font-[sans-serif] max-w-md mx-auto">
                        </div>
                        <label for="uploadFile1"
                            class="bg-blue-100 border-2 border-blue-500 text-blue-500 text-base rounded w-full flex items-center justify-center cursor-pointer gap-2 mb-5 py-2 px-5">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" data-slot="icon" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                            </svg>
                            Upload photo
                            <input type="file" id='uploadFile1' class="hidden" accept="image/*" name="mc_option_image"
                                v-on:change="onMCOptionImageChange" />
                        </label>
                        <div v-if="imageErrorMessage" class="validation_error_msg">This field is required.</div>
                        <button type="submit" @click="updateMenuCycleDayOptionsPhoto"
                            class="md:w-24 w-full button-color text-white font-bold py-3 rounded md:mt-0 mt-4 px-4 leading-4 mx-auto bg-[#38558e]">UPDATE</button>
                    </div>
                </form>

            </div>
        </template>

    </jet-dialog-modal>
</template>

<script>
import vClickOutside from "click-outside-vue3";
var moment = require('moment');
import JetDialogModal from "@/Jetstream/DialogModal";


// import { inject } from 'vue';


export default {


    props: ['products', 'date', 'userLoginCheck', 'closeCalendarPopUp'],
    components: {
        vClickOutside,
        JetDialogModal
    },

    data() {
        return {
            isShow: false,
            optionImage: "",
            menu_cycle_day_options_id: '',
            imageErrorMessage: false,
            optionSetimage: '',
            uploadProgress: '',
            productValue: '',
        }
    },

    methods: {
        showPhotoChangePopUp(p) {
            this.productValue = p;
            this.menu_cycle_day_options_id = p.id
            this.isShow = true;
            console.log('productValueproductValue', this.productValue);
        },

        hideShowLoader(types) {
            if (types == "show") {
                document.getElementById("full_loader").style.display = "flex";
            } else {
                document.getElementById("full_loader").style.display = "none";
            }
        },

        closePhotoChangePopUp() {
            this.imageErrorMessage = false;
            this.optionSetimage = '';
            this.isShow = false;
        },

        updateMenuCycleDayOptionsPhoto() {
            this.hideShowLoader('show');
            if (this.optionImage == null || this.optionImage == '') {
                this.imageErrorMessage = true;
                this.hideShowLoader('hide');
            } else {
                axios.post('/update-recipe-photo', { id: this.menu_cycle_day_options_id, mc_option_image: this.optionImage })
                    .then((response) => {
                        this.productValue.photo = response.data.photo_store_path;
                        this.productValue.photo_store_path = response.data.photo_store_path;
                        this.hideShowLoader('hide');
                        this.optionSetimage = '';
                        this.isShow = false;
                        this.$emit('closeCalendarPopUp');
                        // this.$emit('loadExcludedDateData');
                        // this.$emit('loadCalendar');

                        // return { message1, messge2};
                        console.log(response.data);
                    })
                    .catch(error => console.error(error));
            }

        },

        onMCOptionImageChange(e) {
            let $this = this;
            // this.optionImage = e.target.files[0];
            let img_file = e.target.files || e.dataTransfer.files;

            if (!img_file.length) {
                return;
            } else {
                console.log('hello3');
                this.uploadProgress = true;
                this.createMCOptionImage(img_file[0]);
                Vapor.store(e.target.files[0], {
                    visibility: 'public-read',
                    progress: (progress) => { },
                }).then((response) => {
                    this.uploadProgress = false;
                    $this.optionImage = response;
                    //   console.log("vapor response", response);
                    console.log('imageoption', this.optionImage);
                });
            }
        },

        createMCOptionImage(file) {
            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => {
                vm.optionSetimage = e.target.result;
            };
            reader.readAsDataURL(file);
        },

    }
}
</script>

<style scoped>
.box-hover .bg-white.popup-shadow {
    font-size: 12px;
    width: 460px;
    max-width: 100vw;
}

.bg-white.popup-shadow {
    padding: 0px;
}

.box-hover .bg-white.popup-shadow li.text-black {
    padding: 3px 8px;
    margin-bottom: 5px;
}

.bottom-0-space {
    bottom: 6px;
}
</style>

<style scoped>
.box-hover .bg-white.popup-shadow {
    font-size: 12px;
    width: 460px;
    max-width: 100vw;
}

.bg-white.popup-shadow {
    padding: 0px;
}

.box-hover .bg-white.popup-shadow li.text-black {
    padding: 3px 8px;
    margin-bottom: 5px;
}


.bottom-0-space {
    bottom: 6px;
}
</style>

